(function (angular) {
  "use strict";

  angular.module("app").directive("isLoading", isLoading);

  isLoading.$inject = ["$rootScope", "$templateRequest", "$compile"];

  /**
   * Directive that shows a loading spinner above a form, or other element
   * @ngdoc directive
   * @example
   * <form name="signup" is-loading="vm.isLoading">
   */
  function isLoading($rootScope, $templateRequest, $compile) {
    function isLoadingLink($scope, el) {
      el = $(el);
      angular.extend($scope, { thisSiteSettings: $rootScope.thisSiteSettings });
      $scope.isLoading = $scope.isLoading || false;

      // Watch for change to isLoading
      $scope.$watch("isLoading", function (isLoading) {
        if (isLoading) {
          el.addClass("disabled-while-loading");
          el.find("input, textarea, button").each(function () {
            $(this).attr("disabled", "true");
          });
        } else {
          el.removeClass("disabled-while-loading");
          el.find("input, textarea, select, button").each(function () {
            $(this).removeAttr("disabled");
          });
        }
      });

      // Get template and compile
      $templateRequest("directives/is-loading.html").then(function (html) {
        var template = angular.element(html);
        el.append(template);
        $compile(template)($scope);
      });
    }

    return {
      restrict: "A",
      link: isLoadingLink,
      scope: {
        isLoading: "=",
        isLoadingMessage: "@",
        isLoadingProgress: "=",
      },
    };
  }
})(angular);
